module.exports = __webpack_public_path__ + "static/media/info2.6330bfa1.svg";